import ExportCart from '../../../assets/exportCart';

const Comunity = () => {
  return (
    <>
      <div className="flex flex-col items-center ">
        <h1 className="flex text-center text-5xl text-[#4D4D4D] font-semibold leading-snug phone:text-2xl">
          Manage your entire community <br />
          in a single system
        </h1>
        <p className="text-[#717171] text-xl phone:text-sm">
          Who is Nextcent suitable for?
        </p>
      </div>
      <ExportCart />
    </>
  );
};

export default Comunity;
